import { forwardRef } from 'react'
import { TypingIndicatorProps } from './types'

// eslint-disable-next-line react/display-name
export const TypingIndicator = forwardRef<HTMLDivElement, TypingIndicatorProps>(
  ({ className }, ref) => {
    return (
      <div
        ref={ref}
        className={'flex items-start max-w-2xl mx-auto mt-[20px] ' + className}
      >
        <div className="flex items-center gap-1 rounded-2xl rounded-tl-none bg-white p-3 shadow-sm">
          {[0, 1, 2].map((index) => (
            <div
              key={index}
              className={`size-2 rounded-full ${
                index === 1 ? 'bg-blue-500' : 'bg-blue-200'
              } animate-pulse`}
              style={{
                animationDelay: `${index * 0.2}s`,
                animationDuration: '1.2s'
              }}
            />
          ))}
        </div>
      </div>
    )
  }
)
